import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

import Button from "../../Components/Button/Button";
import InputField from "../../Components/InputField/InputField";
import PageLoader from "../../Components/loaders/PageLoader/PageLoader";

import { clearAllSliceStates, loginUser, logout } from "../../redux/authentication/authSlice";
import "./LoginStyle.css";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LOGIN_ILLUSTRATION = "https://cdn.mastersunion.link/assets/dinero/loginGroup2.png";

const Login = () => {
  const formObject = { email: "", password: "" };
  const [formData, setFormData] = useState(formObject);
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [type, setType] = useState(true);

  const {
    isAuthSliceFetching,
    isAuthSliceSuccess,
    isAuthSliceError,
    authSliceErrorMessage,
  } = useSelector((state) => state.authentication);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = Cookies.get("token");

  useEffect(() => {
    if (isAuthSliceSuccess) {
      dispatch(clearAllSliceStates());
      navigate("/", { replace: true });
    }
  }, [isAuthSliceSuccess]);

  useEffect(() => {
    dispatch(logout());
    if (isAuthSliceError) {
      errorToast();
    }
  }, [isAuthSliceError]);

  const onChangeFormData = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ email: "", password: "" });
  };

  const handleSignIn = () => {
    let newErrors = { email: "", password: "" };

    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+/.test(formData.email)) {
      newErrors.email = "Invalid email address.";
    }

    if (!formData.password) {
      newErrors.password = "Password is required.";
    }

    if (newErrors.email || newErrors.password) {
      setErrors(newErrors);
      return;
    }

    dispatch(loginUser(formData));
  };

  const errorToast = (erroMessage) => {
    toast.error(erroMessage ?? authSliceErrorMessage, {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: false,
      pauseOnHover: true,
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSignIn();
    }
  };

  return (
    <>
      <ToastContainer />
      {!token && (
        <div className="authenticationWrapper">
          {isAuthSliceFetching && <PageLoader />}

          <div className="bgDeco bgDecoLeft" aria-hidden="true">
            <svg viewBox="0 0 220 520" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 60 H80 V130" stroke="#06B6D4" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
              <path d="M40 150 H140 V250 H80" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
              <path d="M20 270 H100 V340" stroke="#06B6D4" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
              <path d="M60 360 H170 V440 H100" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" opacity="0.35"/>
              <path d="M30 460 H110" stroke="#06B6D4" strokeWidth="2" strokeLinecap="round" opacity="0.35"/>
            </svg>
          </div>

          <div className="bgDeco bgDecoRight" aria-hidden="true">
            <svg viewBox="0 0 220 520" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M210 60 H140 V130" stroke="#F472B6" strokeWidth="2" strokeLinecap="round" opacity="0.45"/>
              <path d="M180 150 H80 V250 H140" stroke="#EC4899" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
              <path d="M200 270 H120 V340" stroke="#F472B6" strokeWidth="2" strokeLinecap="round" opacity="0.4"/>
              <path d="M160 360 H50 V440 H120" stroke="#EC4899" strokeWidth="2" strokeLinecap="round" opacity="0.35"/>
              <path d="M190 460 H110" stroke="#F472B6" strokeWidth="2" strokeLinecap="round" opacity="0.35"/>
            </svg>
          </div>

          <div className="loginCard">
            <div className="cardLeft">
              <h1 className="brandHeading">
                Dinero <span className="brandHeadingAccent">Blogs</span>
              </h1>
              <p className="brandTagline">
                Your editorial home for finance insights — publish, manage and
                share stories on money, markets and smart decision-making, all
                from one place.
              </p>
              <img
                src={LOGIN_ILLUSTRATION}
                alt="Dinero Blogs illustration"
                className="brandIllustration"
              />
            </div>

            <div className="cardRight">
              <h2 className="signInHeading">Sign in to the Blogs portal</h2>
              <p className="signInSubText">
                Manage drafts, posts and contributors in one workspace.
              </p>
              <div className="loginWrap">
                <InputField
                  notImp={"notimp"}
                  labelName={"Email ID"}
                  placeholder={"Enter Your Email"}
                  onChange={onChangeFormData}
                  name="email"
                  type={"text"}
                  isError={errors.email ? true : false}
                  erroMessage={errors.email}
                />
                <InputField
                  notImp={"notimp"}
                  labelName={"Password"}
                  placeholder={"Enter Your Password"}
                  onChange={onChangeFormData}
                  name="password"
                  type={type === true ? "password" : "text"}
                  isError={errors.password ? true : false}
                  erroMessage={errors.password}
                  inputIcon={type === true ? "hideIcon" : "viewIcon"}
                  onclick={() => setType(!type)}
                  onKeyPress={handleKeyPress}
                />

                <Button
                  onClick={handleSignIn}
                  className={"BlueFillButton loginButton"}
                  name={"Sign in"}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {token && <Navigate to="/" />}
    </>
  );
};

export default Login;
